var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "1 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0994 16.301V5.21621C18.0994 4.71989 17.6966 4.31708 17.2003 4.31708C16.704 4.31708 16.3012 4.71989 16.3012 5.21621V16.301H5.21649C4.72016 16.301 4.31735 16.7038 4.31735 17.2001C4.31735 17.6965 4.72016 18.0993 5.21649 18.0993H16.3012V29.1914C16.3012 29.6878 16.704 30.0906 17.2003 30.0906C17.6966 30.0906 18.0994 29.6878 18.0994 29.1914V18.0993L29.1886 18.103C29.6849 18.103 30.0877 17.7001 30.0877 17.2038C30.0877 16.7075 29.6849 16.3047 29.1886 16.3047L18.0994 16.301Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAddIcon);
export default __webpack_public_path__ + "static/media/AddAdd_Icon.2cdb0718bf315070ac67d877166b9d8a.svg";
export { ForwardRef as ReactComponent };